import LoadingDots from './LoadingDots';

const ChatBubbleLoading = () => (
  <div className="!tw-mb-4 tw-w-fit tw-max-w-[270px] tw-rounded-b-[10px] tw-rounded-tl-[2px] tw-rounded-tr-[10px] tw-bg-gray-400 tw-px-4 tw-py-3 tw-text-sm">
    <LoadingDots />
  </div>
);

export default ChatBubbleLoading;
